import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useLocale, SUPPORTED_LOCALES, LOCALE_LABELS, type Locale } from "@/lib/i18n";

interface Props {
  variant?: "compact" | "full";
  className?: string;
}

const SHORT: Record<Locale, string> = { en: "EN", es: "ES", fr: "FR", de: "DE" };

const LocaleSwitcher = ({ variant = "compact", className = "" }: Props) => {
  const { locale, setLocale } = useLocale();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`text-[13px] font-medium gap-1.5 min-h-11 min-w-11 ${className}`}
          aria-label={`Change language, currently ${LOCALE_LABELS[locale]}`}
        >
          <Globe className="h-3.5 w-3.5" />
          {variant === "compact" ? SHORT[locale] : LOCALE_LABELS[locale]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {SUPPORTED_LOCALES.map((l) => (
          <DropdownMenuItem
            key={l}
            onClick={() => setLocale(l)}
            className={`text-[13px] cursor-pointer ${l === locale ? "font-semibold text-primary" : ""}`}
          >
            <span className="w-7 text-muted-foreground tabular-nums">{SHORT[l]}</span>
            {LOCALE_LABELS[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LocaleSwitcher;
